import React, { useEffect } from 'react';
import { connect } from "react-redux";
import { stopTimer } from '../common/helper';
import Obr from '../common/Obr';

const ObRef = ({ val, captchaToken, refreshCaptchaToken }) => {
    useEffect(() => {
        stopTimer();
    }, [])

    return (
        <>
            {<div className='bookingStatus_container' style={{ width: '100%' }}>
                <Obr
                    val={val}
                    captchaToken={captchaToken}
                    refreshCaptchaToken={refreshCaptchaToken}
                />
            </div>
            }
        </>
    )
}

const mapStateToProps = function (store) {
    return store;
};

export default connect(mapStateToProps)(ObRef);
